/** Minimal column shape for `@for` track keys (avoids importing the full component). */
export interface KlGridFormColumnTrackInput {
  header: string;
  trackKey?: string;
}

export function columnTrackKey(col: KlGridFormColumnTrackInput, index: number): string {
  return col.trackKey ?? `${col.header}\u0000${index}`;
}
